import {
  InferInput,
  InferOutput,
  number,
  object,
  optional,
  pipe,
  safeParse,
  transform,
  ValiError,
} from 'valibot';
import { ArtistList, ArtistListSchema } from '../apiSchema.ts';

const DEFAULT_MAX_ARTISTS = Number(import.meta.env.VITE_DEFAULT_MAX_ARTISTS);

export const MeLibraryArtistsRequestArgsSchema = pipe(
  object({
    limit: optional(number()),
    offset: optional(number()),
  }),
  transform(({ limit, offset }) => {
    return {
      ...(limit ? { limit } : { limit: DEFAULT_MAX_ARTISTS }),
      ...(offset ? { offset } : {}),
      include: ['catalog' as const],
    };
  }),
);

export type MeLibraryArtistsRequestArgsInput = InferInput<
  typeof MeLibraryArtistsRequestArgsSchema
>;

export type MeLibraryArtistsRequestArgs = InferOutput<
  typeof MeLibraryArtistsRequestArgsSchema
>;

export const MeLibraryArtistsAPISchema = object({
  data: ArtistListSchema,
});

export type MeLibraryArtistsAPI = InferOutput<
  typeof MeLibraryArtistsAPISchema
>;

export const $getMeLibraryArtists = async (
  player: MusicKit.MusicKitInstance,
  args: MeLibraryArtistsRequestArgsInput,
): Promise<ArtistList> => {
  const p = safeParse(
    MeLibraryArtistsRequestArgsSchema,
    args,
  );
  if (!p.success) {
    throw new ValiError(p.issues);
  }

  const res = await player.api.music(
    '/v1/me/library/artists',
    p.output,
  ) as unknown as InferInput<typeof MeLibraryArtistsAPISchema>;
  const parsed = safeParse(
    MeLibraryArtistsAPISchema,
    res,
  );
  if (!parsed.success) {
    throw new ValiError(parsed.issues);
  }
  return parsed.output.data;
};
